const FETCH_NOTIFICATIONS = 'frontend/notifications/FETCH_NOTIFICATIONS';
const CLEAR_NOTIFICATIONS = 'frontend/notifications/CLEAR_NOTIFICATIONS';
const UPDATE_NOTIFICATIONS = 'frontend/notifications/UPDATE_NOTIFICATIONS';
const TOGGLE_CENTRE = 'frontend/notifications/TOGGLE_CENTRE';
const MARK_NOTIFICATION_AS_CLICKED = 'frontend/notifications/MARK_NOTIFICATION_AS_CLICKED';

const initialState = {
  count: 0,
  notifications: [],
  fetched: false,
  centreOpen: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      if (action.payload) {
        return {
          ...state,
          count: action.payload.count,
          notifications: action.payload.notifications,
          fetched: true,
        };
      }
      return state;
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        count: 0,
        notifications: [],
        fetched: false,
      };
    case TOGGLE_CENTRE:
      return {
        ...state,
        centreOpen: !state.centreOpen,
      };
    case UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.notifications,
        count: action.payload.count,
      };
    case MARK_NOTIFICATION_AS_CLICKED:
      return {
        ...state,
        notifications: state.notifications
          .filter(notification => notification.notificationId !== action.payload.notificationId),
      };
    default:
      return state;
  }
}
